import React, { useState } from 'react';
import axios from 'axios';
import './componenetStyle/ImportKlientowMapping.css';

const API_URL = process.env.REACT_APP_API_URL;

function ImportKlientowMapping() {
  const [step, setStep] = useState(1);
  const [file, setFile] = useState(null);
  const [dbColumns, setDbColumns] = useState([]);     
  const [excelColumns, setExcelColumns] = useState([]); 
  const [mapping, setMapping] = useState({});
  const [message, setMessage] = useState("");
  const [duplicates, setDuplicates] = useState([]);
  const [importedCount, setImportedCount] = useState([]);

  // Krok 1: Wybór pliku
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setMessage("");
  };

  // Krok 2: Pobranie kolumn z Excela i DB
  const handleGetColumns = async () => {
    if (!file) {
      setMessage("Wybierz plik!");
      return;
    }
    try {
      const formData = new FormData();
      formData.append('file', file);
      // Pobierz kolumny z pliku Excel
      const excelRes = await axios.post(`${API_URL}/excel-columns`, formData);
      // Pobierz kolumny z bazy danych
      const dbRes = await axios.get(`${API_URL}/klienci-columns`);
      
      // Ustaw otrzymane listy kolumn
      setExcelColumns(excelRes.data.excelColumns);
      setDbColumns(dbRes.data);
      
      // Inicjalizuj mapowanie – tylko dla pól, które chcemy importować.
      // Ustalmy listę pól, które chcemy zaimportować:
      const desiredColumns = [
        'imie', 'nazwisko', 'adres_email', 'nr_telefonu', 'czy_firma', 'rabat', 'grupa_kliencka','rodo_posprzedazowe','rodo_marketingowe', 'kontakt' , 
        'cel_kontaktu', 'rezygnacja_z_przegladow', 'powod_rezygnacji',// dane klienta
        'kraj', 'miasto', 'kod_pocztowy', 'ulica', 'nr_domu', 'nr_lokalu', 'notatka', // dane adresu
        'nazwa', 'model', 'numer_seryjny', 'typ', 'rodzaj', 'uwagi', 'interwal_przegladow', 'data_montazu', 'data_ostatniego_przegladu' // dane urządzenia
      ];
      const initMapping = {};
      desiredColumns.forEach(col => {
        initMapping[col] = ""; // brak przypisania domyślnie
      });
      setMapping(initMapping);
      setStep(2);
    } catch (err) {
      console.error("Błąd pobierania kolumn:", err);
      setMessage("Błąd pobierania kolumn");
    }
  };

  // Aktualizacja mapowania dla danego pola z DB
  const handleMappingChange = (dbColumn, excelColumn) => {
    setMapping(prev => ({ ...prev, [dbColumn]: excelColumn }));
  };

  // Krok 2: Finalny import – wysłanie pliku wraz z mapowaniem
  const handleImport = async () => {
    if (!file) {
      setMessage("Brak pliku!");
      return;
    }
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('mapping', JSON.stringify(mapping));
      const response = await axios.post(`${API_URL}/import-klienci-full`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setMessage(`${response.data.message}. Zaimportowano: ${response.data.importedCount} wierszy.`);
      setDuplicates(response.data.duplicates || []);
      setStep(3);
    } catch (err) {
      console.error("Błąd importu:", err);
      setMessage("Błąd importu klientów");
    }
  };


  const handleForceImport = async (duplicate, index) => {
    try {
      const payload = {
        mapping,       // przekazujemy mapowanie, jeśli jest potrzebne
        row: duplicate.row,
        force: true
      };
      const response = await axios.post(`${API_URL}/import-klient-force`, payload);
      console.log("Import wymuszony:", response.data);
      const newDuplicates = [...duplicates];
      newDuplicates.splice(index, 1);
      setDuplicates(newDuplicates);
      setImportedCount(prev => prev + 1);
    } catch (error) {
      console.error("Błąd wymuszonego importu:", error);
      alert("Błąd wymuszonego importu dla wiersza duplikatu");
    }
  };

  return (
    <div className="import-klientow-container">
      <h2>Import klientów z pliku Excel (mapowanie kolumn)</h2>
      
      {step === 1 && (
        <div className="step1">
          <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} style={{border: "none"}} />
          {file && <p>Wybrano plik: {file.name}</p>}
          <button onClick={handleGetColumns}>Pobierz kolumny</button>
        </div>
      )}

      {step === 2 && (
        <div className="step2">
          <h3>Mapowanie kolumn</h3>
          <p>Przypisz, która kolumna z Excela odpowiada której kolumnie w bazie:</p>
          {Object.keys(mapping).map(dbCol => (
            <div key={dbCol} className="mapping-row">
              <label>{dbCol}</label>
              <select style={{maxWidth: "200px"}}
                value={mapping[dbCol] || ""}
                onChange={(e) => handleMappingChange(dbCol, e.target.value)}
              >
                <option value="">-- Brak --</option>
                {excelColumns.map(exCol => (
                  <option key={exCol} value={exCol}>{exCol}</option>
                ))}
              </select>
            </div>
          ))}
          <button onClick={handleImport}>Importuj</button>
        </div>
      )}

        {step === 3 && (
        <div className="step3">
            <h3>Import zakończony</h3>
            <p>{message} Zaimportowano: {importedCount} wierszy.</p>

            {duplicates.length > 0 && (
            <div className='import-result'>
                <h4>Duplikaty (nie zostały zaimportowane):</h4>
                <table >
                <thead>
                    <tr>
                    <th>Wiersz z danymi</th>
                    <th>Powód duplikatu</th>
                    <th>Opcje</th>
                    </tr>
                </thead>
                <tbody>
                    {duplicates.map((dup, idx) => (
                    <tr key={idx}>
                        <td >{JSON.stringify(dup.row)}</td>
                        <td>{dup.duplicateMessages.join(", ")}</td>
                        <td>
                        <button onClick={() => handleForceImport(dup, idx)}>Importuj</button>
                        </td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
            )}

            <button onClick={() => setStep(1)}>Importuj kolejny plik</button>
        </div>
        )}

      {message && step !== 3 && <p className="message">{message}</p>}
    </div>
  );
}

export default ImportKlientowMapping;
